import { render, staticRenderFns } from "./personalNews.vue?vue&type=template&id=53b80a41&scoped=true"
import script from "./personalNews.vue?vue&type=script&lang=js"
export * from "./personalNews.vue?vue&type=script&lang=js"
import style0 from "./personalNews.vue?vue&type=style&index=0&id=53b80a41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b80a41",
  null
  
)

export default component.exports